import { CancellationPolicy } from '../../store/PolicyManagement/policyManagementTypes';

export const calculatePolicyFine = (
  fromDate: number,
  policy: CancellationPolicy
): number => {
  if (!policy || !fromDate) {
    return 0;
  }

  const millInHour = 60 * 60 * 1000;
  const eventStartDate = fromDate;
  const now = Date.now();

  const policyOption = policy.options.find(
    // eslint-disable-next-line no-mixed-operators
    (option) => option.hours * millInHour + now > eventStartDate
  );

  if (!policyOption) {
    return 0;
  }

  return policyOption.fine;
};
